export const MEDIA_QUERY_MAX_768 = '(max-width: 768px)';
